import React, { useState } from "react";
import "./FAQ.css";

export default function FAQ({ title = "FAQ", items = [] }) {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => {
    setOpenIndex((prev) => (prev === i ? -1 : i));
  };

  return (
    <section className="faq-wrap">
      <h2 className="faq-title">{title}</h2>

      <div className="faq-list">
        {items.map((it, i) => {
          const open = i === openIndex;
          return (
            <div key={i} className={`faq-item ${open ? "open" : ""}`}>
              <button
                type="button"
                className="faq-q"
                onClick={() => toggle(i)}
                aria-expanded={open}
              >
                <span>{it.q}</span>
                <span className="faq-icon">{open ? "−" : "+"}</span>
              </button>

              {open && <div className="faq-a">{it.a}</div>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
